import React, { useContext } from 'react'
import Style from './Navbar.module.css'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../assets/images/freshcart-logo.svg';
import { UserContext } from '../../context/userAuth';
import { paths } from '../../utils/routes';
import { CartContext } from '../../context/CartContext';

export default function Navbar() {

  const { userToken, setUserToken } = useContext(UserContext);
  const { cartCount } = useContext(CartContext)
  const navigator = useNavigate();
  const logOut = () => {
    try {
      localStorage.removeItem('userToken')
      setUserToken(null);
      navigator(paths.login);
    } catch (error) {
      alert(error.toString());
    }
  }


  return (
    <nav className="navbar navbar-expand-sm navbar-light bg-light">
      <div className="container">
        <img className='me-2' src={logo} alt="Fresh Cart" />
        <button className="navbar-toggler d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavId" aria-controls="collapsibleNavId" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="collapsibleNavId">

          {userToken && <ul className="navbar-nav me-auto mt-2 mt-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/products">Productds</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/categories">Categories</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/brands">Brands</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/cart">Cart</Link>
            </li>
          </ul>}

          <ul className='navbar-nav ms-auto mt-2 mt-lg-0'>
            {!userToken && <>
              <li className='nav-item'><Link className='nav-link' to='/register'>Register</Link></li>
              <li className='nav-item'><Link className='nav-link' to='/login'>Login</Link></li>

            </>}
            <li className='d-flex align-items-center'>
              <i className='fab fa-facebook mx-2'></i>
              <i className='fab fa-twitter mx-2'></i>
              <i className='fab fa-instagram mx-2'></i>
              <i className='fab fa-tiktok mx-2'></i>
              <i className='fab fa-youtube mx-2'></i>
            </li>
            {/* <li><div><i className="fa-solid fa-cart-shopping"></i>
              <span>{cartCount}</span>
            </div></li> */}
            {userToken && <li className='nav-item'><span className='nav-link cursor-pointer' onClick={() => logOut()}  >Logout</span></li>}
          </ul>
        </div>
      </div>
    </nav>

  )
}
